(function() {

    'use strict';

    angular.module('app').
    controller('VehicleDetailsController', VehicleDetailsController);

    VehicleDetailsController.$inject = ['$scope',
        '$q',
        '$routeParams',
        '$timeout',
        '$location',
        'toastr',
        'FleetService',
        'ConfirmationModalFactory',
        'CropperModalService',
        'ViewChangeNotificationFactory',
        'Units',
        '$rootScope',
        'hasDuplicate',
        'Upload'
    ];

    function VehicleDetailsController(
        $scope,
        $q,
        $routeParams,
        $timeout,
        $location,
        toastr,
        FleetService,
        ConfirmationModalFactory,
        CropperModalService,
        ViewChangeNotificationFactory,
        Units,
        $rootScope,
        hasDuplicate,
        Upload
    ) {
        const vm = this;
        const {id, fleetId, vehicleTypeId, driverId} = $routeParams;

        const redirectBaseURL = {
            fleetId: '/fleets/details/',
            vehicleTypeId: '/fleets/vehicle-types/details/',
            driverId: '/fleets/drivers/details/'
        };
        const viewConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.viewChange.MESSAGE',
            code: 'messages.warning.viewChange.CODE',
        });
        const toInactiveConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.TO_VEHICLE_INACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });
        const toActiveConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.TO_VEHICLE_ACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });
        const deleteConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.DELETE_RECORD',
            code: 'messages.warning.statusChange.CODE'
        });
        const driverAssingConf = new ConfirmationModalFactory({}, {
            message: 'messages.warning.driverVehicleChange.MESSAGE',
            code: 'messages.warning.driverVehicleChange.CODE'
        });
        
        const cropperModal = new CropperModalService();

        const onRouteChange = $scope.$on('$routeChangeStart', function(event, next, current, test) {
            if(!vm.viewMode && isDataChanged(vm.vehicle, vm.vehicleRaw)){
                viewConfirmation.getInstance().result.then(function (cond) {
                    if (cond) {
                        onRouteChange();
                        let nextRoute = next.$$route.originalPath;
                        if( _.contains(next.$$route.originalPath, ':') ){
                            nextRoute = nextRoute.split(':')[0];
                        }
                        $location.path(nextRoute);
                    }
                });
                event.preventDefault();
            }
        });
        const notAvailableOption = {
            name: 'N/A',
            id: null
        };
        const measureUnit = Units.getMeasureUnit($rootScope.GlobalProfile.office.measureUnit);
        vm.measureUnit = measureUnit ? measureUnit === 'CM' ? 'M' : 'F' : 'M';
        vm.weightUnit = Units.getWeightUnit($rootScope.GlobalProfile.office.weightUnit);
        angular.extend(vm, {
           id, fleetId, typeId: vehicleTypeId
        });
        vm.viewMode = false;
        vm.searchVehicleTypes = searchVehicleTypes;
        vm.searchFleets = searchFleets;
        vm.searchDrivers = searchDrivers;
        vm.changeStatus = changeStatus;
        vm.saveVehicle = saveVehicle;
        vm.deleteVehicle = deleteVehicle;
        vm.upload = upload;
        vm.openCropper = openCropper;
        vm.isUnique = isUnique;
        vm.getPreviousRoute = getPreviousRoute;
        vm.plateNoDimension = {width: 1200, height: 1200};
        vm.vehicleDimension = {width: 1200, height: 1200};

        (()=>{
            vm.isFetching = true;
            const initCalls = {
                vehicle: getVehicle(),
                fleet: getFleet(),
                vehicleType: getVehicleType()
            };
            $q.all(initCalls).then(data=>{
                getDriver(data.vehicle.driverId).then(driver=>{
                    initVehicle(data, driver);
                }).finally(()=>vm.isFetching = false);
            }).catch(err=>{

            }).finally(()=>{
            });
            initYears();

            $scope.$watch('vm.vehicle.driver', (driver) => {
                if(vm.vehicleRaw != undefined) {
                    if((driver.id != vm.vehicleRaw.driver.id) && driver.currentVehicle != null) {
                        showChangeConf(driver);
                    }
                }
            });
        })();
        function showChangeConf(driver){
            driverAssingConf.getInstance().result.then(cond => {
                if(cond){
                    vm.vehicle.driver = driver;
                    vm.vehicleRaw.driver = driver;
                }
            });
        }
        function initVehicle(data, driver) {
            const {
                maxHeight,
                maxLength,
                maxVolume,
                maxWeight,
                maxWidth,
                minHeight,
                minLength,
                minWeight,
                minWidth
            } = data.vehicle;
            const result = angular.extend(data.vehicle, {
                driver: driver || data.driver || notAvailableOption,
                vehicleType: data.vehicle.vehicleType || data.vehicleType || null,
                fleet: data.vehicle.fleet || data.fleet || notAvailableOption
            }, {
                maxHeight: maxHeight / 100,
                maxLength: maxLength / 100,
                //maxVolume: maxVolume / 100,
                //maxWeight: maxWeight / 100,
                maxWidth: maxWidth / 100,
                minHeight: minHeight / 100,
                minLength: minLength / 100,
                //minWeight: minWeight / 100,
                minWidth: minWidth / 100
            });
            vm.vehicle = result;
            vm.vehicleRaw = angular.copy(result);
        }
        function initYears() {
            let minYr = new Date(0).getFullYear();
            let curYr = new Date().getFullYear();
            vm.years = ['N/A', curYr];
            do {
                curYr -= 1;
                vm.years.push(curYr);
            }while(curYr >= minYr)
        }
        function getVehicle() {
            const defer = $q.defer();
            if(!vm.id){
                $timeout(()=>{
                    defer.resolve({});
                });
            }else{
                FleetService.Vehicles.get(vm.id, data=>{
                    defer.resolve(data);
                }, error=>{
                    toastr.error('Vehicle not found', error.message);
                    defer.reject(error);
                    vm.isFetching = false;
                });
            }

            return defer.promise;
        }
        function getDriver(driverId) {
            const defer = $q.defer();
            if(!driverId){
                $timeout(()=>{
                    defer.resolve(notAvailableOption);
                });
            }else{
                FleetService.Drivers.get(driverId, data=>{
                    defer.resolve(data);
                }, error=>{
                    toastr.error('Driver not found', error.message);
                    defer.reject(error);
                });
            }

            return defer.promise;
        }
        function getFleet() {
            const defer = $q.defer();
            if(!fleetId){
                $timeout(()=>{
                    defer.resolve(null);
                });
            }else {
                FleetService.Fleets.get(fleetId, data => {
                    defer.resolve(data);
                }, error => {
                    toastr.error('Fleet not found', error.message);
                    defer.reject(error);
                });
            }
            return defer.promise;
        }
        function getVehicleType() {
            const defer = $q.defer();
            if(!vehicleTypeId){
                $timeout(()=>{
                    defer.resolve(null);
                });
            }else {
                FleetService.VehicleTypes.get(vehicleTypeId, data => {
                    defer.resolve(data);
                }, error => {
                    toastr.error('Fleet not found', error.message);
                    defer.reject(error);
                });
            }
            return defer.promise;
        }
        function isUnique(model, field) {
            vm.checkingDups = true;
            hasDuplicate({
                serviceCallback: FleetService.Vehicles.getAll,
                callbackFormat: ['success', 'error', 'filter'],
                findBy: 'content',
                compareWith: model,
                compareBy: field,
                raw: angular.getObjVal(vm, 'vehicleRaw.' + field),
                filters: {
                    size: 2,
                    page: 0,
                    sort: 'id,desc',
                    [field]: model
                }
            }).then(res => {
                vm[field + 'Error'] = res ? field === 'vehicleId' ? 'Vehicle ID is already taken' : 'Plate number is already taken' : null;
                vm.checkingDups = false;
            }).catch(err => {
                vm.checkingDups = false;
            });
        }
        function searchVehicleTypes(select) {
            if(!select.open)
                return false;
            vm.searching = true;
            vm.vehicleTypes = [];
            FleetService.VehicleTypes.getAll(data=>{
                vm.vehicleTypes = [...data.content];
                vm.searching = false;
            }, error=> {
                vm.searching = true;
                toastr.error('Unable to search for vehicle types', error.message);
            }, {
                name: select.search
            })
        }
        function searchFleets(select) {
            if(!select.open)
                return false;
            vm.searching = true;
            vm.fleets = [];
            FleetService.Fleets.getAll(data=>{
                vm.fleets = [notAvailableOption, ...data.content];
                vm.searching = false;
            }, error=> {
                vm.searching = true;
                toastr.error('Unable to search for vehicle types', error.message);
            }, {
                name: select.search
            })
        }
        function searchDrivers(select) {
            if(!select.open)
                return false;
            vm.searching = true;
            vm.drivers = [];
            FleetService.Drivers.getAll(data=>{
                vm.drivers = [notAvailableOption, ...data.content];
                vm.searching = false;
            }, error=> {
                vm.searching = true;
                toastr.error('Unable to search for vehicle types', error.message);
            }, {
                firstName: select.search
            });
        }
        function changeStatus(event, active) {
            event.preventDefault();
            if (vm.vehicle.active) {
                vm.vehicle.active = false;
                toActiveConf.getInstance().result.then(function(cond) {
                    if (cond) {
                        $timeout(function () {
                            vm.vehicle.active = true;
                        });
                    }
                });
            }
            else {
                vm.vehicle.active = true;
                toInactiveConf.getInstance().result.then(function(cond) {
                    if (cond) {
                        $timeout(function () {
                            vm.vehicle.active = false;
                        });
                    }
                });
            }
        }
        function isDataChanged(o, n) {
            return !angular.equals(cleanPayload(o), cleanPayload(n));
        }
        function cleanPayload(payload) {
            let {
                active,
                assistantOnBoard,
                color,
                driver,
                equippedWithTrolley,
                hasTailGateLifter,
                fleet,
                make,
                maxHeight,
                maxLength,
                //maxVolume,
                maxWeight,
                maxWidth,
                minHeight,
                minLength,
                minWeight,
                minWidth,
                model,
                owner,
                plateNumber,
                plateNumberPhotoUrl,
                vehiclePhotoUrl,
                vehicleId,
                vehicleType,
                year,
            } = payload;
            return {
                active,
                assistantOnBoard,
                color,
                driverId: angular.getObjVal(driver, 'id'),
                equippedWithTrolley,
                hasTailGateLifter,
                fleetId: angular.getObjVal(fleet, 'id'),
                make,
                maxHeight: maxHeight * 100,
                maxLength: maxLength * 100,
                //maxVolume: maxVolume * 100,
                maxWeight,
                maxWidth: maxWidth * 100,
                minHeight: minHeight * 100,
                minLength: minLength * 100,
                minWeight,
                minWidth: minWidth * 100,
                model,
                owner,
                plateNumber,
                plateNumberPhotoUrl,
                vehiclePhotoUrl,
                vehicleId,
                vehicleTypeId: angular.getObjVal(vehicleType, 'id'),
                year
            }
        }
        function getPreviousRoute() {
            if(fleetId)
                return redirectBaseURL.fleetId + fleetId;
            if(vehicleTypeId)
                return redirectBaseURL.vehicleTypeId + vehicleTypeId;
            if(driverId)
                return redirectBaseURL.driverId + driverId;
            return ('../');
        }
        function saveVehicle(form) {
            form.$setSubmitted();
            if(form.$invalid){
                return false;
            }
            vm.saveInProgress = true;
            $q.all({
                vehiclePhoto: upload(vm.croppedVehiclePhoto || vm.vehiclePhoto, 'vehiclePhotoUrl', true),
                plateNoPhoto: upload(vm.croppedPlateNo || vm.plateNoFile, 'plateNumberPhotoUrl', false)
            }).finally(data=>{
                if($routeParams.id){
                    FleetService.Vehicles.update(vm.id, cleanPayload(vm.vehicle), result=>{
                        vm.saveInProgress = false;
                        toastr.success('Data successfully updated');
                        vm.vehicleRaw = angular.copy(vm.vehicle);
                    }, err=>{
                        vm.saveInProgress = false;
                        toastr.error(err.message);
                    })
                }else{
                    FleetService.Vehicles.create(cleanPayload(vm.vehicle), result=>{
                        onRouteChange();
                        if(fleetId){
                            $location.path(redirectBaseURL.fleetId + fleetId);
                        }else if(vehicleTypeId){
                            $location.path(redirectBaseURL.vehicleTypeId + vehicleTypeId);
                        }else{
                            $location.path('fleets/vehicles/details/' + result.id);
                        }
                        toastr.success('Data successfully created');
                    }, err=>{
                        vm.saveInProgress = false;
                        toastr.error(err.message);
                    })
                }
            });
        }
        function deleteVehicle(vehicle) {
            deleteConf.getInstance().result.then(cond=>{
                if(cond){
                    FleetService.Vehicles.delete(vehicle.id, data=>{
                        toastr.success('Vehicle successfully deleted');
                        onRouteChange();
                        $location.path('/fleets/vehicles');
                    }, err=>{
                        toastr.error('Unable to do request. Please try again later', err.message);
                    })
                }
            });
        }
        function upload(file, field, isVehiclePhoto) {
            const defer = $q.defer();

            if(!file){
                $timeout(()=>{
                    defer.resolve(null);
                });
            }else{
                vm.vehicle[field] = file;
                vm[field+ 'Uploading'] = true;
                Upload.resize(file, {width: 600, height: 600}).then(resizedFile=> {
                    FleetService.Vehicles.upload(resizedFile, data => {
                        vm.vehicle[field] = data;
                        vm[field + 'Uploading'] = false;
                        defer.resolve();
                    }, err => {
                        vm[field + 'Uploading'] = false;
                        toastr.error('Unable to upload photo', err.messsage);
                        defer.resolve();
                    }, {isVehiclePhoto})
                });
            }

            return defer.promise;
        }
        function openCropper(load, fieldName) {
            cropperModal.setImageFile(load);
            cropperModal.getInstance().result.then(newImage=>{
                 vm[fieldName] = cropperModal.dataURItoBlob(newImage, load.$ngfName);
            });
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/fleets/VehicleDetailsController.js